import { render, staticRenderFns } from "./DifficultyLabel.vue?vue&type=template&id=18b5fb14&scoped=true&"
import script from "./DifficultyLabel.vue?vue&type=script&lang=js&"
export * from "./DifficultyLabel.vue?vue&type=script&lang=js&"
import style0 from "./DifficultyLabel.vue?vue&type=style&index=0&id=18b5fb14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b5fb14",
  null
  
)

export default component.exports